<template lang="pug">
md-layout(md-flex='100')
  md-layout(md-flex='90', md-flex-offset='5')
    md-card.md-table-card.content-table
      md-card-header.md-title
        | Domain reportin
      form.search-form(novalidate, @submit.stop.prevent='resetPaginationAndSearch')
        md-layout(:md-gutter='24', md-flex='100')
          md-layout(md-flex='30', md-flex-small='40', md-flex-xsmall='50')
            date-input(v-model='filters.startDate', :validation='$v.filters.startDate', :formSubmitted='true', label="From date")
          md-layout(md-flex='30', md-flex-small='40', md-flex-xsmall='50')
            date-input(v-model='filters.endDate', :validation='$v.filters.endDate', :formSubmitted='true', label="To date")
          md-layout(md-flex='10', md-flex-small='10', md-flex-xsmall='100', md-vertical-align='center', md-align-xsmall='center')
            md-button.search-btn.md-raised.md-icon-button.btn(type='submit', :disabled='loading || $v.$invalid')
              md-icon.icon(md-iconset="fa fa-search")

        md-layout(md-flex='90')
          md-layout(md-flex='70', md-flex-small='100')
            a.filter-link.md-primary(@click='getFrom("today")') Today
            a.filter-link.md-primary(@click='getFrom("yesterday")') Yesterday
            a.filter-link.md-primary(@click='getFrom("last_week")') Last 7 days
            a.filter-link.md-primary(@click='getFrom("this_month")') This month
            a.filter-link.md-primary(@click='getFrom("last_month")') Last month
          md-layout(md-flex='30', md-flex-small='100', md-align='end')
            md-button.md-primary.md-raised.md-dense(md-theme='rhebus-blue', @click='exportCSV', :disabled='loading || $v.$invalid') Export CSV

      stitch-loader(:loading='loading', :size='45')
      div
        div.titleLine.styleRow
          p.rowElements Date
          p.rowElements Distribution
          p.rowElements Domain
          p.rowElements Network
          p.rowElements Content
          p.rowElements Feeds Loaded
          p.rowElements Content Starts
        div.styleRow.colorHover(v-for='domain in domains')
          div.rowElements {{ domain.date }}
          div.rowElements {{ domain.distribution }}
          div.rowElements {{ domain.domain }}
          div.rowElements {{ domain.network }}
          div.rowElements {{ domain.content }}
          div.rowElements {{ domain.feedLoaded }}
          div.rowElements {{ domain.contentStarts }}
        
        md-table-pagination(
          :md-size='currentPagination.size',
          :md-total='totalEntries',
          :md-page='currentPagination.page',
          md-label='Entries',
          md-separator='of',
          :md-page-options='[50, 100]',
          @pagination='onPageChanged'
        )

        //- .table
          md-table
            md-table-header
              md-table-row
                md-table-cell.bold Date
                md-table-cell.bold Distribution
                md-table-cell.bold Domain
                md-table-cell.bold Network
                md-table-cell.bold Content
                md-table-cell.bold Feeds Loaded
                md-table-cell.bold Content Starts
            md-table-body
              md-table-row(v-for='domain in domains')
                md-table-cell {{ domain.date }}
                md-table-cell {{ domain.distribution }}
                md-table-cell {{ domain.domain }}
                md-table-cell {{ domain.network }}
                md-table-cell {{ domain.content }}
                md-table-cell {{ domain.feedLoaded }}
                md-table-cell {{ domain.contentStarts }}
          md-table-pagination(
            :md-size='currentPagination.size',
            :md-total='totalEntries',
            :md-page='currentPagination.page',
            md-label='Entries',
            md-separator='of',
            :md-page-options='[50, 100]',
            @pagination='onPageChanged'
          )
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { validationMixin } from 'vuelidate';
  import Period from '../../common/utils/periods';
  import reportService from '../../services/reportService';
  import stitchLoader from '../../shared-components/Loader';
  import DateInput from '../../shared-components/forms/DateInput';
  import { isValidDate } from '../../services/validatorService';
import auth0 from 'auth0-js';

  export default {
    mixins: [validationMixin],
    components: {
      DateInput,
      stitchLoader
    },
    data() {
      return {
        domains: [],
        loading: false,
        sort: {
          name: 'date',
          type: 'asc'
        },
        totalEntries: 0,
        currentPagination: {
          size: 50,
          page: 1
        },
        filters: {
          startDate: '',
          endDate: ''
        }
      };
    },
    validations: {
      filters: {
        startDate: {
          isValidDate(value) {
            return isValidDate(value);
          }
        },
        endDate: {
          isValidDate(value) {
            return isValidDate(value);
          }
        }
      }
    },
    computed: {
      totals() {
        const totals = {
          feedLoaded: 0,
          contentStarts: 0,
          tech: 0.0,
          cpm: 0.0,
          contentCPM: 0.0,
          contentFee: 0.0,
          fee: 0.0
        };
        this.domains.forEach((domain) => {
          totals.feedLoaded += Number(domain.feedLoaded);
          totals.contentStarts += Number(domain.contentStarts);
          totals.tech += parseFloat(domain.tech);
          totals.cpm += parseFloat(domain.cpm);
          totals.contentCPM += parseFloat(domain.contentCPM);
          totals.contentFee += parseFloat(domain.contentFee);
          totals.fee += parseFloat(domain.fee);
        });
        return totals;
      },
      searchParams() {
        const params = {
          offset: this.currentPagination.size * (this.currentPagination.page - 1),
          limit: this.currentPagination.size
        };
        const { startDate, endDate } = this.filters;
        if (startDate) {
          Object.assign(params, { startDate });
        }
        if (endDate) {
          Object.assign(params, { endDate });
        }

        return params;
      }
    },
    methods: {
      resetPaginationAndSearch() {
        this.search();
      },
      onPageChanged(paginationParams) {
        this.currentPagination = paginationParams;
        this.search();
      },
      onSort(sortParams) {
        this.sort = sortParams;
        this.resetPaginationAndSearch();
      },
      getFrom(period) {
        const { startDate, endDate } = Period.periods(period);
        this.filters.startDate = startDate;
        this.filters.endDate = endDate;
        this.resetPaginationAndSearch();
      },
      search() {
        this.loading = true;
        reportService.domainsReport(this.searchParams)
          .then((response) => {
            const data = response.data;
            if (data) {
              this.domains = data.domains;
              this.totalEntries = data.total;
              this.domains.forEach((domain) => {
                domain.date = moment.utc(domain.date).format('MM-DD-YYYY');
              });
            }
            this.loading = false;
          })
          .catch((error) => {
            console.error('Error while retrieving billing report', error);
          })
          .then(() => {
            this.loading = false;
          });
      },
      exportCSV() {
        this.loading = true;
        const params = this.searchParams;
        Object.assign(params, this.searchParams, { export: 1 });
        reportService.domainsReport(params)
          .then((response) => {
            const blob = new Blob([response.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const hiddenLink = document.createElement('a');
            document.body.appendChild(hiddenLink);
            hiddenLink.style.display = 'none';
            hiddenLink.href = url;
            hiddenLink.download = 'report.csv';
            hiddenLink.click();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error('Error while getting the CSV file', error);
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    mounted() {
      this.search();
    }
  };
</script>

<style lang="scss" scoped>
  .search-form {
    margin-top: 20px;
    width: 100%;
  }
  .table {
    margin-top: 20px;

    .title {
      margin-left: 15%;
      font-size: 1.5em;
    }

    .bold {
      font-weight: 800;
    }

    .end {
      text-align: right;
    }
  }
  .content-table {
    width: 100%;
    margin-top: 20px !important;
    padding-left: 10px;
    padding-right: 10px;
    margin: auto;
  }
  .md-table {
    .md-sortable.md-sorted, .md-sortable:hover {
      color: #0198cf;
    }
  }

.styleRow p {
  font-weight: 600;
}
.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.colorHover:hover{
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}


</style>



// WEBPACK FOOTER //
// src/shared-components/report/DomainsTable.vue